import { tv } from 'tailwind-variants';

export const mainCarouselStyles = tv({
  slots: {
    viewport: `
      w-full
      cursor-pointer
      select-none
      overflow-hidden
      focus:outline-none
    `,
    container: `
      grid
      min-h-[400px]
      auto-cols-[100%]
      grid-flow-col
    `,
  },
});

export const navigatorCarouselStyles = tv({
  slots: {
    viewport: `
      h-full
      w-full
      cursor-pointer
      select-none
      overflow-hidden
    `,
    container: `
      flex
      h-full
      w-full
      flex-row
      gap-2
      md:flex-col
    `,
  },
});

export const arrowStyles = tv({
  base: `
    p-2

    text-neutral-700
    hover:text-green-700
    focus:outline-none

    [&_svg]:h-5
    [&_svg]:w-5
  `,
});
